import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";
import { analyse, docLines } from "@/lib/poetry/lines";
import { checkForm } from "@/lib/poetry/forms";

export const poetryKey = new PluginKey("poetry");

const mark = (row) => {
  const el = document.createElement("span");
  el.className = "lf-syl";
  el.contentEditable = "false";
  const bad = (row.target && !row.ok) || row.letterOk === false;
  el.dataset.state = bad ? "off" : row.target ? "ok" : "plain";
  el.title = [row.target ? `Aim for ${row.target[0] === row.target[1] ? row.target[0] : `${row.target[0]}–${row.target[1]}`} syllables${row.why ? ` (${row.why})` : ""}` : "",
    row.rhymeWith ? `Should rhyme with line ${row.rhymeWith}` : ""].filter(Boolean).join(" · ");
  el.textContent = `${row.syl}${row.letter ? ` ${row.letter}` : ""}`;
  return el;
};

const build = (doc, opts) => {
  if (opts.mode !== "poem" && opts.mode !== "song") return DecorationSet.empty;
  const { rows } = checkForm(opts.form, analyse(docLines(doc)));
  const decos = rows.filter((r) => !r.blank && !r.header).map((r, i) => Decoration.widget(r.end, () => mark(r), { side: 1, ignoreSelection: true, key: `${i}:${r.syl}:${r.letter}:${r.ok}:${r.letterOk}:${r.target || ""}:${r.expected || ""}` }));
  return DecorationSet.create(doc, decos);
};

export const PoetryMarks = Extension.create({
  name: "poetryMarks",
  addOptions() { return { mode: "prose", form: "free" }; },
  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        const st = poetryKey.getState(editor.state);
        const { $from, empty } = editor.state.selection;
        if (!st || (st.opts.mode !== "poem" && st.opts.mode !== "song") || !empty || $from.parent.type.name !== "paragraph") return false;
        if ($from.nodeBefore?.type.name === "hardBreak" && !$from.nodeAfter) {
          return editor.chain().command(({ tr }) => { tr.delete($from.pos - 1, $from.pos); return true; }).splitBlock().run();
        }
        return editor.commands.setHardBreak();
      },
    };
  },
  addProseMirrorPlugins() {
    const start = { ...this.options };
    return [new Plugin({
      key: poetryKey,
      state: {
        init: (_, { doc }) => ({ opts: start, decos: build(doc, start) }),
        apply: (tr, prev) => {
          const meta = tr.getMeta(poetryKey);
          const opts = meta ? { ...prev.opts, ...meta } : prev.opts;
          return tr.docChanged || meta ? { opts, decos: build(tr.doc, opts) } : prev;
        },
      },
      props: { decorations(state) { return poetryKey.getState(state).decos; } },
    })];
  },
});

export const refreshPoetry = (editor, patch) => {
  if (!editor || editor.isDestroyed) return;
  editor.view.dispatch(editor.state.tr.setMeta(poetryKey, patch || {}));
};
